import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const CampaignsApi = createApi({
  reducerPath: "CampaignsApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["CAMPAIGNSAPI"],
  endpoints: (build) => ({
    getCampaigns: build.query({
      query: ({
        page = 1,
        search = "",
        status = "",
        limit = 10,
      }) => ({
        url: `/campaigns?page=${page}&search=${search}&status=${status}&limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CAMPAIGNSAPI"],
    }),

    getCampaignById: build.query({
      query: (id) => ({
        url: `/campaigns/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CAMPAIGNSAPI"],
    }),

    getCampaignStats: build.query({
      query: () => ({
        url: `/campaigns/stats/overview`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CAMPAIGNSAPI"],
    }),

    createCampaign: build.mutation({
      query: (data) => ({
        url: `/campaigns`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CAMPAIGNSAPI"],
    }),

    updateCampaign: build.mutation({
      query: ({ id, data }) => ({
        url: `/campaigns/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CAMPAIGNSAPI"],
    }),

    updateCampaignStatus: build.mutation({
      query: ({ id, status }) => ({
        url: `/campaigns/${id}/status`,
        method: "PATCH",
        body: { status },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CAMPAIGNSAPI"],
    }),

    deleteCampaign: build.mutation({
      query: (id) => ({
        url: `/campaigns/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CAMPAIGNSAPI"],
    }),
  }),
});

export const {
  useGetCampaignsQuery,
  useGetCampaignByIdQuery,
  useGetCampaignStatsQuery,
  useCreateCampaignMutation,
  useUpdateCampaignMutation,
  useUpdateCampaignStatusMutation,
  useDeleteCampaignMutation,
  useLazyGetCampaignByIdQuery,
  useLazyGetCampaignsQuery,
} = CampaignsApi;